<template>
  <div class="md-layout">
    <!-- 主体 -->
    <div class="md-layout-item md-size-100">
      <!-- 卡片 -->
      <md-card>
        <md-card-content>
          <!-- 卡片-查询表单 -->
          <div class="md-layout card-form" style="max-width: 700px;">
            <div class="md-layout-item md-size-25 left-layout-item md-xsmall-size-50">
              <md-field>
                <md-select v-model="searchForm.searchType" >
                  <md-option value="ip">{{$I18n('search_by_ip')}}</md-option>
                  <md-option value="uid">{{$I18n('search_by_uid')}}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25 left-layout-item md-xsmall-size-50">
              <md-field>
                <label v-if="searchForm.searchType === 'ip'">IP</label>
                <label v-if="searchForm.searchType === 'uid'">UID</label>
                <md-select v-if="searchForm.searchType === 'ip'" v-model="searchForm.ip">
                  <md-option v-for="item in ipList" :key="item.value" :value="item.value">{{item.name}}</md-option>
                </md-select>
                <md-input v-if="searchForm.searchType === 'uid'" v-model="searchForm.uid"/>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25">
              <md-button class= "left-icon md-info " @click="form_changeSearchData">
                <md-icon>search</md-icon>{{$I18n("search")}}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
      <md-card>
        <md-card-content>
          <div class="md-layout-item right-layout-item">
            <md-button class= "left-icon md-info" @click="get_file">
              <md-icon>file_download</md-icon>
              {{$I18n("create_xls_state")}}
            </md-button>
            <md-button class= " md-info" @click="form_downloadXlsx">
              <md-icon>file_download</md-icon>
              {{$I18n("export_record")}}
            </md-button>
          </div>
          <md-table v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="'UID'">{{ item.uid }}</md-table-cell>
              <md-table-cell :md-label="$I18n('continent')">{{ item.region_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('country')">{{ item.zone_name }}</md-table-cell>
              <md-table-cell :md-label="'IP'">{{ item.ip }}</md-table-cell>
              <md-table-cell :md-label="$I18n('port')">{{ item.port ?item.port :"" }}</md-table-cell>
              <md-table-cell :md-label="'MAC'">{{ item.mac }}</md-table-cell>
              <md-table-cell :md-label="$I18n('net_type')">{{ item.net_type }}</md-table-cell>
              <md-table-cell :md-label="$I18n('state')">{{ item.dev_state }}</md-table-cell>
              <md-table-cell :md-label="$I18n('srv_ip')">{{ item.srv_ip }}</md-table-cell>
              <md-table-cell :md-label="$I18n('srv_zone')">{{ item.srv_zone_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('pontime')">{{ item.create_time }}</md-table-cell>
              <md-table-cell :md-label="$I18n('pofftime')">{{ item.off_time }}</md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">
              {{$I18n("none_data")}}
            </md-table-empty-state>
          </md-table>
          <table-page :total="total" :pageSize="pageSize" v-model="currentPage"/>
        </md-card-content>
      </md-card> 
    </div>
    <!-- 弹窗 -->
    <simple-modal 
      ref    = "modal"
      :title = "modalTitle"
      :right = "true"
      :submitBtn="openModalType==='create_xls'"
      @submit= "modal_submit"
    >
      <template slot="body">
        <!-- 导出xls的选项  -->
        <div v-if="openModalType === 'create_xls'">
          <div class="md-layout"> 
            <!-- 订单所属公司 (select) -->
            <modal-form-item :label='"IP"' :required="true" class="md-layout-item md-size-50">
              <md-field>
                <md-select v-model="exportForm.link_id" >
                  <md-option value="__ALL__">{{$I18n("all")}}</md-option>
                  <md-option v-for="item in ipList" :key="item.value" :value="item.value">{{item.name}}</md-option>
                </md-select>
              </md-field>
            </modal-form-item>
          </div>
        </div>
        <!-- 导入文件表格弹窗 -->
        <div v-else>
          <md-table v-model="modalTableData" class="left-table">
            <md-table-row slot="md-table-row" slot-scope="{item}">
              <md-table-cell :md-label="$I18n('apply_time')">
                <div :style="{'textAlign':'left'}">{{ item.create_time }}</div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('sys')">
                <div :style="{'textAlign':'left'}">{{ item.sys }}</div>
              </md-table-cell>
              <md-table-cell :md-label="'IP'">
                <div :style="{'textAlign':'left'}">{{ item.link_id }}</div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('state')">
                <div :style="{'textAlign':'left'}">{{ item.state_name }}</div>
              </md-table-cell>
              <md-table-cell :md-label="$I18n('operate')">
                <div v-if="item.file_url" :style="{'textAlign':'left'}">
                  <a :href="item.file_url">{{$I18n("download_file")}}</a>
                </div>
                <div v-else :style="{'textAlign':'left'}">{{$I18n('download_file')}}</div>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
          <table-page :total="import_total" :pageSize="import_pageSize" v-model="import_currentPage"/>
        </div>
      </template>
    </simple-modal>
  </div>
</template>
<script>
import {timestampToString} from "@/common/tools.js";
export default {
  props: ["userinfo_sys"],
  data() {
    return {
      openModalType: "",
      modalTitle : "",
      modalTableData: [],
      import_currentPage : 1,
      import_pageSize : 10,
      import_total : 0,
      exportForm:{
        link_id : "__ALL__",
      },

      ipList  : [],
      searchForm : {
        ip         : "",
        uid        : "",
        searchType :"ip",
      },
      searchData : {
        srv_ip  : "",
        uid     : "",
      },
      continent : {
        "AF" : this.$I18n("africa"),
        "EU" : this.$I18n("europe"),
        "AS" : this.$I18n("asia"),
        "OC" : this.$I18n("oceania"),
        "OA" : this.$I18n("oceania"),
        "NA" : this.$I18n("north_america"),
        "SA" : this.$I18n("latin_america"),
        "AN" : this.$I18n("antarctica"),
      },
      // 表格相关
      icon  : "computer",
      title : this.$I18n("device_info"),
      tableInitData : [], // 表格数据

      // 分页相关
      pageSize : 10,
      currentPage : 1,
      total : 0,

    };
  },
  mounted : function() {
    let getIp = () => {
      if(this.userinfo_sys != ""){
        this.api_getServerData();
      }else {
        setTimeout(getIp, 300)
      }
    }
    let getData = () => {
      if(this.userinfo_sys != "" && this.searchForm.ip != ""){
        this.searchData.srv_ip = this.searchForm.ip
        this.api_getPageData();
      }else {
        setTimeout(getData, 300)
      }
    }

    getIp()
    getData()
  },
  watch: { 
    'userinfo_sys' : {
      handler(){
        this.api_getModalServerData();
        this.api_getServerData();
      }
    },
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    currentPage(){
      this.api_getPageData()
    },
    import_currentPage(){
      this.api_getXlsData();
    },
  },
  computed: {
    // 表格数据
    tableData(){
      if (!this.tableInitData || this.tableInitData.length === 0){
        return [];
      } else {
        return [...this.tableInitData]
          .map(item => {
            let dev_state = ""
            let net_type = ""
            switch(item.nt){
              case "1":
              case 1:
                net_type = this.$I18n("net_type_1");
                break;
              case "2":
              case 2:
                net_type = this.$I18n("net_type_2");
                break;
              case "3":
              case 3:
                net_type = this.$I18n("net_type_3");
                break;
              case "4":
              case 4:
                net_type = this.$I18n("net_type_4");
                break;
              case "5":
              case 5:
                net_type = this.$I18n("net_type_5");
                break;
              case "0":
              case 0:
              default:
                net_type = this.$I18n("net_type_0");
                break;
            }
            switch(item.state){
              case "1":
              case 1:
                dev_state = this.$I18n("dev_state_1");
                break;
              case "0":
              case 0:
              default:
                dev_state = this.$I18n("dev_state_0");
                break;
            }
            return {
              ...item,
              net_type,
              dev_state,
              region_name : this.continent[item.region],
              zone_name : item.zone ?this.$I18n(item.zone) :"",
              srv_zone_name : item.srv_zone ?this.$I18n(item.srv_zone) :"",
              create_time: item.time ?timestampToString(item.gmt_time * 1000) :"",
              off_time: item.pofftime ?timestampToString(item.pofftime * 1000) :"",
            }
          })
      }
    },
    tablePageData(){
      return this.tableData
    }
  },
  methods: {
    modal_submit(){
      this.$api.getDevStateXls({
        sys:       this.userinfo_sys,
        link_id :  this.exportForm.link_id == "__ALL__" ?"" : this.exportForm.link_id,
        link_type: this.exportForm.link_id == "__ALL__" ?0 :1,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("get_success"));
          this.$refs.modal.close();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    form_downloadXlsx(){
      this.api_getXlsData();
      this.openModalType = "import"
      this.modalTitle = this.$I18n("export_record");
      this.$refs.modal.open();
    },
    get_file(){
      this.openModalType = "create_xls"
      this.modalTitle = this.$I18n("create_xls_state");
      this.$refs.modal.open();

      this.exportForm = {
        sys: this.userinfo_sys,
        link_id : "__ALL__",
      }
    },
    api_getXlsData(){
      this.$api.getDevStateExport({
        page_no  : this.import_currentPage,
        page_size  : this.import_pageSize,
      })
        .then(this.$Then(res => {
          this.modalTableData = res.data.map(item => {
            let state_name = ""
            if(item.state === 1){
              state_name = this.$I18n("is_export")
            } else if(item.state === 2){
              state_name = this.$I18n("export_fail")
            } else if(item.state === 3){
              state_name = this.$I18n("export_succ")
            }
            return {
              ...item,
              state_name,
              create_time: timestampToString(item.gmt_create * 1000),
              update_time: timestampToString(item.gmt_create * 1000),
            }
          })
          this.import_total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.modalTableData = [];
          this.import_total = 0;
        }))
    },
    // 获取页面信息
    api_getServerData(){
      // 获取角色
      this.$api.getServerList({
        "sys" :this.userinfo_sys,
        "type": 12,
        "page_no": 1,
        "page_size": 9999,
      })
        .then(this.$Then(res => {
          if(!res.data.ips){
            this.ipList = [];
            this.searchForm.ip = "";
          } else {
            this.ipList = res.data.ips.sort((a,b) => {
              return a.zone.localeCompare(b.zone, "en")
            }).map(item => {
              return {
                name: this.$I18n(item.zone) + "-" +item.net_addr,
                value: item.net_addr,
              }
            });
            this.searchForm.ip = this.ipList[0].value;
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.ipList = [];
          this.searchForm.ip = "";
        }))
    },
    api_getPageData(){
      this.$api.getDeviceState({
        ...this.searchData,
        sys: this.userinfo_sys,
        page_size : this.pageSize,
        page_no : this.currentPage,
      })
        .then(this.$Then(res => {
          this.tableInitData = res.data;
          this.total  = res.count
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.tableInitData = [];
          this.total  = 0;
        }))
    },
    // 更改查询条件(并立刻查询)
    form_changeSearchData () {
      this.searchData = {
        sys : this.userinfo_sys,
        srv_ip : this.searchForm.searchType == "ip" ?this.searchForm.ip : "",
        uid    : this.searchForm.searchType == "uid" ?this.searchForm.uid : "",
      };
      this.api_getPageData();
    },
  },
}
</script>
<style lang="scss" scoped>
  .canclick:hover, .canclick.selected {
    color : #26c6da;
    cursor: pointer;
  }
  .left-btn {
    text-align:left;
  }
  .md-date-form-item {
    height : 36px;
    border : none;
  }
  .left-table{
    margin-top: 16px;
  }
  .card-form {
    margin-top: 12px;
  }
  // 左侧表单对齐表格
  .left-layout-item{
    padding-rigth:8px;
    padding-left:8px;
  }
  // 表单右侧对齐表格
  .right-layout-item{
    text-align: right;
    padding:0;
  }

  // 表单里的单选框
  .radio-layout{
    margin-top: 6px;
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  //左侧iocn
  .left-icon{
    margin-left: 16px;
  }
  // flaot 右的按钮
  .right-button {
    float:right;
  }

  .text-right .md-table-cell-container {
    display: flex;
    justify-content: flex-end;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }

  .table-stats {
    display: flex;
    align-items: center;
    text-align: right;
    flex-flow: row wrap;

    .td-price .td-total {
      display: inline-flex;
      font-weight: 500;
      font-size: 1.0625rem;
      margin-right: 50px;
    }

    &.table-striped .td-price {
      border-bottom: 0;
    }

    .td-price {
      font-size: 26px;
      border-top: 1px solid #ddd;
      border-bottom: 1px solid #ddd;
    }

    .td-price,
    > div {
      flex: 0 0 100%;
      padding: 12px 8px;
    }
  }
</style>
